//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import {getFullUrl} from '@nuskin/ns-common-lib';
import pagedown from 'pagedown';

export default {
  name: 'Disclaimers',
  props: {
    general: {
      type: String,
      default: ''
    },
    disclaimers: {
      type: Array,
      default: () => []
    },
    warnings: {
      type: Array,
      default: () => []
    }
  },
  computed: {
    siteUrl() {
      return this.$store.getters['nuskin/siteUrl'] || '';
    }
  },
  methods: {
    buildWarningBody(markdownText) {
      const markdownLinkRegex = /\[(?<linkText>.*)\]\((?<linkUrl>.*)\)/;
      markdownText = markdownText.replace(markdownLinkRegex, (...args) => {
        const {linkText, linkUrl} = args[args.length - 1];
        return `[${linkText}](${getFullUrl(this.siteUrl, linkUrl)})`;
      });
      const safeConverter = pagedown.getSanitizingConverter();
      const html = safeConverter.makeHtml(markdownText);
      // open links in new tab
      const modifiedHtml = html.replace(/<a /g, `<a target="_blank" `);
      return modifiedHtml;
    }
  }
};
